import {
  Identifiable,
  Project,
  ProjectResource,
  Resource,
  Role,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function saveResourceInProject(httpClient: HttpClient, linker: Linker) {
  return (
    resource: Identifiable<Resource>,
    project: Identifiable<Project>,
    role: Identifiable<Role>,
  ) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<ProjectResource>>>({
        endpoint: "/projectMembers",
        method: HttpMethods.POST,
        data: {
          member: `resource/${resource.uuid}`,
          project: `project/${project.uuid}`,
          role: `role/${role.uuid}`,
        },
      })
      .then(linker.linkProjectResource);
}

export { saveResourceInProject };
